import { DistanceType } from "../enums/DistanceType";

export class DiagnosticInformationBase {
  id?: number;
  diagnosticInformationId?: number;
  distanceType: DistanceType = DistanceType.Far;
  leftSpherical: string;
  leftCylindrical: string;
  leftAxis: string;
  leftNasoPupillaryDistance: string;
  rightSpherical: string;
  rightCylindrical: string;
  rightAxis: string;
  rightNasoPupillaryDistance: string;
  createByName: string;
  updateByName: string;
}